import { render } from "./auth-callback.vue?vue&type=template&id=0766699a&ts=true"
import script from "./auth-callback.vue?vue&type=script&setup=true&lang=ts"
export * from "./auth-callback.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/auth/auth-callback.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0766699a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0766699a', __exports__)) {
    api.reload('0766699a', __exports__)
  }
  
  module.hot.accept("./auth-callback.vue?vue&type=template&id=0766699a&ts=true", () => {
    api.rerender('0766699a', render)
  })

}


export default __exports__